import axios from "axios";
import store from "../store";
import Cookies from "js-cookie";
import { getAnalyticsConsentHeaderValue } from "../helpers/consent";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT_URL,
});

instance.interceptors.request.use(
  async (config) => {
    const token = Cookies.get("token") || "";
    const locale = localStorage.getItem("locale") || "en";
    config.headers.Authorization = `Bearer ${token}`;
    config.headers["x-locale"] = locale;
    config.headers["x-list-id"] = store.getters["config/bookingEngineId"];
    config.headers["x-domain"] = window.location.hostname;
    config.headers["x-origin"] = window.location.origin;
    const analyticsConsent = getAnalyticsConsentHeaderValue();
    if (analyticsConsent) {
      config.headers["x-analytics-consent"] = analyticsConsent;
    }
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export default instance;
